export default __webpack_public_path__ + "static/media/check.c4775852.svg";